import BarcodePaywallTrigerer from "features/home/Paywall/BarcodePlaywallTrigerer"
import { useNavigate } from "react-router-dom"
import PATHS from "router/paths"
import { ActionItem, ActionItemTitle } from "./styled"
import { BarcodeIcon, LockedIcon } from "./Icons"
import { FlexBox } from "components/Common/FlexBox"

interface BarcodeScanSectionProps {
  hasBarcodeScanningEntitlement: boolean
  getUserPlanLoading: boolean
}

const BarcodeScanAction = ({
  hasBarcodeScanningEntitlement,
  getUserPlanLoading,
}: BarcodeScanSectionProps) => {
  const navigate = useNavigate()

  const onTryBarcodeScanning = () => {
    if (getUserPlanLoading) return

    if (!hasBarcodeScanningEntitlement) {
      return
    }

    navigate(`${PATHS.app.barcodeScanner.root}`)
  }

  return (
    <BarcodePaywallTrigerer>
      <ActionItem onClick={onTryBarcodeScanning}>
        <BarcodeIcon />
        <FlexBox $alignItems="center" $justify="center" $gap={4}>
          {!hasBarcodeScanningEntitlement && <LockedIcon />}
          <ActionItemTitle>Barcode</ActionItemTitle>
        </FlexBox>
      </ActionItem>
    </BarcodePaywallTrigerer>
  )
}

export default BarcodeScanAction
